import { DocumentNode } from "graphql";
import { useRecoilValue } from "recoil";
import { userPersonalInfoState } from "../store/user";
import { useDataSubscription } from "./useDataModule";

interface SubscriptionForUpdatesProps {
	onCompleted: (data: any) => void;
	query: DocumentNode;
	unfiltered?: boolean;
}

const SubscriptionForUpdates = ({ onCompleted, unfiltered, query }: SubscriptionForUpdatesProps) => {
	const {
		organization: { externalId },
	} = useRecoilValue(userPersonalInfoState);
	useDataSubscription(query, {
		onSubscriptionData: ({ subscriptionData: { data } }) => {
			const key = data && Object.keys(data)[0];
			if ((key && data[key]?.includes?.(externalId)) || unfiltered) {
				onCompleted(data);
			}
		},
	});

	return null;
};

export default SubscriptionForUpdates;
